"use client"
// CMP-0142 · LFS Edge Image · Catalog Engine · Lot Discovery · owner: Platform
// 99-1: /Users/yogeshmathur/ym/lot-for-sale-ph/docs/design-handoff/README.md
// 99-1-decision: EXTEND next/image (adopted image component) with a loader only; same props and look. Addresses end in
// .jpg so Cloudflare stores them at its Manila edge, the way spire.com.ph and storage.housal.com are already served.
import Image, { type ImageProps } from "next/image"
import cdnImageLoader from "@/lib/lfs/image-loader"

export default function LfsImage(props: ImageProps) {
  // eslint-disable-next-line jsx-a11y/alt-text -- alt is passed through in props
  return <Image loader={cdnImageLoader} {...props} />
}
